import { render } from "./InputTime.vue?vue&type=template&id=72f53566"
import script from "./InputTime.vue?vue&type=script&lang=js"
export * from "./InputTime.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__